module.exports = __webpack_public_path__ + "img/corto.bf446efd.png";